<section
  class="2fa-setup-section container-fluid sts-section sts-form">


  <app-sts-section-header key="sts-setup-2fa-header" [errors]="errors">Two-Step Verification Setup
  </app-sts-section-header>

  <app-sts-section-body key="sts-setup-2fa-body">
    <div class="col-24 verify-instruction-top">
      <p>
        Add an additional verification step for a higher level of protection for your account.
      </p>
      <p>
        To turn on two-step verification, please indicate your preferred communication method.  Please be sure to verify that the information you provided is correct.
      </p>
      <p>
        Once you turn two-step verification on, you will be required to enter an additional verification code on top of your user ID and password for an extra layer of security.
      </p>
      <p>
        Each time you log into the website with a non-trusted device, a one-time verification code will be sent to you which will be required to successfully authenticate you.
      </p>

    </div>

  </app-sts-section-body>

  <form (ngSubmit)="submit()" autocomplete="off"
        #form="ngForm"
        [formGroup]="tfaForm"
        class="sts-form animate-all">

    <div class="row sts-form-row ">
      <div class="col-24">
        <input type="checkbox"
               [disabled]="allowModification"
               formControlName="enrol"
               id="sts-enrol-2fa" name="enrol" />
        <label for="sts-enrol-2fa" app-sts-cms-txt key="sts-enrol-2fa">Use two-step verification when logging in</label>
      </div>
    </div>

    <div class="row sts-form-row sts-form-last-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <div>
            <label app-sts-cms-txt key="sts-pick-2fa-login-email" for="sts_pick_email">
              Personal email address to send authentication code to:
            </label>
            <input type="text"
                   name="sts_pick_email"
                   id="sts_pick_email"
                   formControlName="email"
                   maxlength="100"
                   [ngClass]="{'has-errors' : !emailIsValid}"
                   class="sts-textbox" />
            <div class="text-danger" *ngIf="tfaForm.controls['email'].invalid && (tfaForm.controls['email'].dirty || tfaForm.controls['email'].touched)">
              <div app-sts-cms-txt key="sts-email-is-unique-required" *ngIf="tfaForm.controls['email'].errors['emailRequired']">An email is required</div>
              <div app-sts-cms-txt key="sts-email-is-valid-required" *ngIf="tfaForm.controls['email'].errors['validateEmail']">A valid email is required</div>
            </div>
          </div>
        </div>
        <!-- -->

      </div>
    </div>

    <div class="row">
      <div class="col-24">
        <label app-sts-cms-txt key="sts-pick-login-totp" for="sts_pick_email">
          Configure secure one-time password tokens:
        </label>
      </div>
    </div>

    <div class="row sts-form-row sts-form-last-row" *ngIf="qrImage">
      <div class="col-24">
        <img [src]="qrImage" alt="" class="pull-left">
        <div app-sts-cms-txt key="sts-2fa-timebased-token-instruction" class="pull-left col-12">
          Download an application like <strong>Microsoft Authenticator</strong> or <strong>Google Authenticator</strong>
          on your mobile device and scan the QR image to the left.
        </div>
        <div class="clearfix no-font"></div>
      </div>

    </div>


    <div class="row sts-form-row sts-form-last-row">
      <div class="col-24">

        <!-- -->
        <div class="sts-object">
          <div>
            <label app-sts-cms-txt key="sts-pick-login-2fa-phone" for="sts_pick_email">
              Configure a mobile phone to receive SMS text message:
            </label>
            <input type="text"
                   name="sts_pick_phone"
                   id="sts_pick_phone"
                   formControlName="phone"
                   maxlength="100"
                   [ngClass]="{'has-errors' : !phoneIsValid}"
                   class="sts-textbox" />
            <div class="text-danger" *ngIf="tfaForm.controls['phone'].invalid && (tfaForm.controls['phone'].dirty || tfaForm.controls['phone'].touched)">
              <div app-sts-cms-txt key="sts-email-is-valid-required" *ngIf="tfaForm.controls['phone'].errors['validatePhone']">A valid phone</div>
            </div>
          </div>
        </div>
        <!-- -->

      </div>
    </div>




    <div class="row sts-form-last-row">
      <div class="col-14">
        <button app-sts-cms-txt key="sts-cancel-button"
                class="sts-btn other-sts-btn"
                (click)="gotoHome()">
          Cancel
        </button>
        <app-sts-button [submit]="submitter"
                        key="sts-next-button">
          Next
        </app-sts-button>
      </div>
    </div>

  </form>



</section>
